const PARAGRAPH_HEADER = (uuid: string, language: string) => `
  paragraphsDataUUID(uuid: "${uuid}", language: "${language}") {
    ... on HeaderParagraph {
      id
      dek
      icon
      title
      type
      uuid
    }
  }
`;

export default PARAGRAPH_HEADER;
